module.exports = __webpack_public_path__ + "img/blue_067.766bea44.png";